import React from "react";
import styled, { css } from "styled-components";

import type { AccountOrRecipient } from "../../../../shared/domains/transactions/customer-instruction";
import { AccountButton, SourceAndDestinationEnum } from "../../screen/transfer/components/source-and-destination";
import { theme } from "../../styles/theme";
import FormLabel from "../forms/form-label";
import { ChevronIcon } from "../svg/chevron";

interface SourceAccountSelectionProps {
  sourceAccount: AccountOrRecipient | null;
  onOpenSourceAccountSelection?: () => void;
  editingSourceAndDestination?: SourceAndDestinationEnum | null;
  formatMessage: (id: string) => string;
}

export const SourceAccountSelection: React.FC<SourceAccountSelectionProps> = ({
  sourceAccount,
  onOpenSourceAccountSelection,
  editingSourceAndDestination,
  formatMessage,
}) => (
  <>
    <FormLabel size="normal" margin="normal" label="amountSelection.since" required />
    {sourceAccount ? (
      <AccountButton
        account={sourceAccount}
        onClick={() => {
          onOpenSourceAccountSelection?.();
        }}
      />
    ) : (
      <SourceAndDestinationButton
        type="button"
        $active={editingSourceAndDestination === SourceAndDestinationEnum.Source}
        onClick={() => {
          onOpenSourceAccountSelection?.();
        }}
      >
        {formatMessage("amountSelection.choose_source_account")}
        <ChevronIcon width={18} height={18} style={{}} />
      </SourceAndDestinationButton>
    )}
  </>
);

const SourceAndDestinationButton = styled("button")<{ disabled?: boolean; $active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  appearance: none;
  border: none;
  height: 48px;
  box-shadow: none;
  background-color: white;
  text-align: left;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;
  ${theme.bodyBlackRegular};
  ${(props) =>
    props.$active &&
    css`
      color: ${theme.mainColor()};
      svg {
        fill: ${theme.mainColor()};
      }
    `}
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    `}
`;
